import {
    WindowViewModel,
    ComponentManager,
    RADEnvironmentProxy,
    LabelViewModelBuilder,
    ButtonViewModelBuilder,
    DropDownListViewModel,
    LabelViewModel,
    ButtonViewModel,
    IWindowViewModelConstructorParameter,
    DetailViewContext,
} from 'radpresentation.htmlclient.defaultviewextensions';

interface ILandesverbandItem
{
    pdoId: string;
    name: string;
}

interface ILandesverbandWechselnDialogViewModelParams extends IWindowViewModelConstructorParameter
{
    context?: DetailViewContext;
    onOk: (selectedLvPdoId: string) => void;
}

export default class LandesverbandWechselnDialogViewModel extends WindowViewModel
{

    public infoLabel: LabelViewModel;
    public landesverbandDropdown: DropDownListViewModel;
    public cancelButton: ButtonViewModel;
    public okButton: ButtonViewModel;

    private selectedLvPdoId: KnockoutObservable<string>;
    private onOk: (selectedLvPdoId: string) => void;

    constructor(params: { newcomerPdoId: string; onOk: (selectedLvPdoId: string) => void }) {
        super({
            ...params,
            isModal: true,
            allowClose: true,
            isDraggable: false,
            isResizable: false,
            width: 480,
            height: 250,
            headline: new LabelViewModelBuilder()
                .withCaption('Landesverband wechseln')
                .build(),
        });

        this.onOk = params.onOk;
        this.selectedLvPdoId = this.observableOrDefault<string>(null);

        this.infoLabel = this.createInfoLabel();
        this.landesverbandDropdown = this.createDropdown();
        this.cancelButton = this.createCancelButton();
        this.okButton = this.createOkButton();

        this.loadLandesverbaende(params.newcomerPdoId);
    }

    private createInfoLabel(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withCaption('Bitte wählen Sie einen neuen Landesverband für den Newcomer')
            .build();
    }

    private createDropdown(): DropDownListViewModel {
        const DropDownListViewModelClass = ComponentManager.getViewModel<typeof DropDownListViewModel>('DropDownListViewModel');
        return new DropDownListViewModelClass({
            data: [],
            value: this.selectedLvPdoId,
            dataTextField: 'name',
            dataValueField: 'pdoId',
            locator: 'lv-wechseln.dropdown',
        });
    }

    private createCancelButton(): ButtonViewModel {
        return new ButtonViewModelBuilder()
            .initForCancelButton('lv-wechseln', () =>
            {
                this.isOpen(false);
            })
            .build();
    }

    private createOkButton(): ButtonViewModel {
        return new ButtonViewModelBuilder()
            .initForOkayButton('lv-wechseln', () =>
            {
                const selectedId = this.selectedLvPdoId();
                if (selectedId == null)
                {
                    return;
                }
                this.isOpen(false);
                this.onOk(selectedId);
            })
            .withIsEnabled(this.defineComputed(() => this.selectedLvPdoId() != null))
            .build();
    }

    private loadLandesverbaende(newcomerPdoId: string): void {
        const principalsRequest = RADEnvironmentProxy.getInstance().getPrincipals();
        const newcomerRequest = RADEnvironmentProxy.getInstance().getObject({
            pdTypeName: 'ONV.ONV.Newcomer',
            pdoID: newcomerPdoId,
            properties: [],
        });

        $.when(principalsRequest, newcomerRequest).then((principals, genericDTO) =>
        {
            if (this.isDisposed)
            {
                return;
            }

            const items: ILandesverbandItem[] = principals
                .filter(p => p.name !== genericDTO.principalName)
                .map(p => ({
                    pdoId: p.pdoId,
                    name: p.fullName,
                }));

            (this.landesverbandDropdown.data as KnockoutObservableArray<ILandesverbandItem>)(items);
        });
    }
}

ComponentManager.setViewModel('LandesverbandWechselnDialog', LandesverbandWechselnDialogViewModel, 'ONVHTMLViewExtension');
